import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrl: './captcha.component.scss',
  standalone: false,
})
export class CaptchaComponent {
  public selectedWord: string;
  public errorMessage: string = '';

  public form = new FormGroup({
    userWord: new FormControl('', [Validators.required]),
  });

  constructor(private dialogRef: DynamicDialogRef) {
    // select a random word from the captchaWords array
    this.selectedWord =
      this.captchaWords[Math.floor(Math.random() * this.captchaWords.length)];
  }
  public captchaWords: string[] = [
    'Feinmotorik',
    'Grobmotorik',
    'Sensomotorik',
    'Neuroplastizität',
    'Tonusregulation',
    'Wahrnehmungsverarbeitung',
    'Handlungsplanung',
    'Vestibuläres System',
    'Propriozeption',
    'Taktiler Sinn',
    'Bilaterale Koordination',
    'Reflexintegration',
    'Hemiparese',
    'Dysphagie',
    'Ataxie',
    'Spastik',
    'Tremor',
    'Motorisches Lernen',
    'Spiegeltherapie',
    'Zentrale Sensibilisierung',
    'ADHS',
    'Autismus-Spektrum-Störung',
    'Entwicklungsverzögerung',
    'Dyspraxie',
    'Handtherapie',
    'Feinmotorik-Training',
    'Schreibmotorik',
    'Graphomotorik',
    'Stifthaltung',
    'Sensory Integration',
    'Bobath-Konzept',
    'Affolter-Modell',
    'Perfetti-Methode',
    'Basale Stimulation',
    'Frühförderung',
    'Tonusdysbalance',
    'Lateralisation',
    'Gleichgewichtstraining',
    'Muskeltonus',
    'Hirnleistungstraining',
    'Neurorehabilitation',
    'Spiegelneuronen',
    'Aphasie',
    'Kognitive Dysfunktion',
    'Ergotherapeutische Befundung',
    'Selbsthilfetraining',
    'Alltagstraining',
    'Hilfsmittelversorgung',
    'Sensibilitätsstörung',
    'Schmerzmanagement',
  ];

  public closeDialog(confirmed: boolean) {
    if (this.selectedWord !== this.form.get('userWord').value && confirmed) {
      this.errorMessage =
        'Das eingegebene Wort stimmt nicht mit dem vorgegebenen Wort überein.';
      return;
    }

    this.dialogRef.close(confirmed);
  }
}
